export default "__VITE_ASSET__747c15aa__"